import { render, staticRenderFns } from "./InstantSearch.vue?vue&type=template&id=6d343342&"
import script from "./InstantSearch.vue?vue&type=script&lang=js&"
export * from "./InstantSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports